import MainPage from "./Components/MainPage";
import Home from "./Components/Pages/Home";
import Copyrights from "./Components/UI/Copyrights";


function App() {
  return (
    <div>
        <MainPage />
        <Home />
        <Copyrights />
    </div>
  );
}

export default App;
